import type { ReactNode } from 'react';

interface SectionHeadingProps {
  title: string;
  icon?: string;
  action?: ReactNode;
  description?: string;
}

export default function SectionHeading({ title, icon, action, description }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div>
        <h2 className="flex items-center gap-2 font-heading font-bold text-lg md:text-xl text-foreground-950">
          {icon && (
            <span className="flex items-center justify-center w-6 h-6 text-accent-500">
              <i className={icon} />
            </span>
          )}
          {title}
        </h2>
        {description && (
          <p className="mt-1 text-sm text-foreground-500">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}